let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3juag")).then(() => parcelRequire('5BFd5'));